/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Reject1Inputs */

const vi_driverremittance_reject1 = /** @type {(inputs: Driverremittance_Reject1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ chối`)
};

/**

* @param {Driverremittance_Reject1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_reject1 = /** @type {((inputs?: Driverremittance_Reject1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Reject1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_reject1(inputs)
});
export { driverremittance_reject1 as "driverRemittance_reject" }